export const PuissanceTriphase = [
  { key: "10A", value: "10A" },
  { key: "15A", value: "15A" },
  { key: "20A", value: "20A" },
  { key: "25A", value: "25A" },
  { key: "30A", value: "30A" },
  { key: "DT", value: "Double tarif (> 30A)" },
];
